import { z } from 'zod';
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 200;
export const EMAIL_MAX_LENGTH = 254;
/**
 * El email se valida en el borde y se normaliza antes de persistir. El límite
 * de longitud evita que una entrada enorme llegue al hash o a la base de datos.
 */
export const emailSchema = z
    .string()
    .trim()
    .min(3)
    .max(EMAIL_MAX_LENGTH)
    .pipe(z.email())
    .transform((value) => value.toLowerCase());
/**
 * Solo longitud mínima: las reglas de composición (mayúsculas, símbolos) empujan
 * a contraseñas predecibles sin aumentar la entropía real.
 */
export const passwordSchema = z.string().min(PASSWORD_MIN_LENGTH).max(PASSWORD_MAX_LENGTH);
export const registerRequestSchema = z.object({
    email: emailSchema,
    password: passwordSchema,
});
export const loginRequestSchema = z.object({
    email: emailSchema,
    // En login no se exige longitud mínima: revelaría la política a un atacante
    // y una contraseña antigua más corta debe poder seguir entrando.
    password: z.string().min(1).max(PASSWORD_MAX_LENGTH),
});
/** DTO público de usuario. Nunca incluye passwordHash. */
export const publicUserSchema = z.object({
    id: z.uuid(),
    email: z.string(),
    createdAt: z.iso.datetime(),
});
export const csrfTokenSchema = z.object({ csrfToken: z.string().min(1) });
export const CSRF_HEADER = 'x-csrf-token';
export const SESSION_COOKIE = 'gc_session';
//# sourceMappingURL=auth.js.map